import React from "react";
import Grid from "@mui/material/Grid2";
import { Typography, Button } from "@mui/material";
import SMS from "../assets/images/sms_snippet.png";
import { styled } from "@mui/material/styles";

const PREFIX = "SMSData";

const classes = {
  smsContainer: `${PREFIX}-smsContainer`,
  smsData: `${PREFIX}-smsData`,
  smsImage: `${PREFIX}-smsImage`,
  smsHeading: `${PREFIX}-smsHeading`,
  smsContent: `${PREFIX}-smsContent`,
  smsContent2: `${PREFIX}-smsContent2`,
  smsContent3: `${PREFIX}-smsContent3`,
  smsContent4: `${PREFIX}-smsContent4`,
  smsHeading2: `${PREFIX}-smsHeading2`,
  exploreButtonStyle: `${PREFIX}-exploreButtonStyle`,
  buttonStyles: `${PREFIX}-buttonStyles`,
  buttonContainer: `${PREFIX}-buttonContainer`,
};

const StyledGrid = styled(Grid)(({ theme }) => ({
  [`& .${classes.smsContainer}`]: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "2em 1em 1em 2em",
    textAlign: "center",
    // marginTop: "1rem",
    // marginBottom: "1rem",
    [theme.breakpoints.up("md")]: {
      flexDirection: "row",
      textAlign: "left",
    },
  },
  [`& .${classes.smsData}`]: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "center",
    textAlign: "center",
    marginTop: "1rem",
    marginBottom: "1rem",
    padding: "2rem 2rem 2rem 3rem",

    [theme.breakpoints.up("sm")]: {
      alignItems: "flex-start",
      textAlign: "left",
      padding: "2rem 2rem 2rem 5rem",
    },
  },
  [`& .${classes.smsImage}`]: {
    display: "flex",
    justifyContent: "center",
    marginTop: "1rem",
    padding: "3%",
    [theme.breakpoints.up("md")]: {
      justifyContent: "flex-end",
    },
    "& img": {
      maxWidth: "300px",
      height: "100%",
      [theme.breakpoints.down("sm")]: {
        maxWidth: "200px",
        height: "100%",
      },
    },
  },
  [`& .${classes.smsHeading}`]: {
    // padding: "2em 1em 0em 1.75em",
    paddingBottom: "1rem",
    fontSize: 32,
    fontWeight: "600",
    fontFamily: "AvenirLTStd-Book",
    textAlign: "left",
    letterSpacing: "0.66px",
    color: "#223140",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      padding: 0,
      marginTop: "1em",
      fontSize: 20,
      textAlign: "left",
      // paddingLeft: " 1rem",
    },
    [theme.breakpoints.between("sm", "md")]: {
      // padding: "2em 1em 1em 1em",
      fontSize: 25,
      textAlign: "left",
    },
    [theme.breakpoints.up("md")]: {
      fontSize: 25,
      textAlign: "left",
    },
    [theme.breakpoints.up("sm")]: {
      textAlign: "left",
    },
  },
  [`& .${classes.smsHeading2}`]: {
    // padding: "2em 1em 0em 1.75em",
    paddingBottom: "1rem",
    fontSize: 36,
    fontWeight: "600",
    fontFamily: "AvenirLTStd-Book",
    textAlign: "left",
    letterSpacing: "0.66px",
    color: "#223140",
    width: "90%",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      padding: 0,
      marginTop: "1em",
      fontSize: 28,
      textAlign: "left",
      // paddingLeft: " 1rem",
    },
    [theme.breakpoints.between("sm", "md")]: {
      // padding: "2em 1em 1em 1em",
      fontSize: 25,
      textAlign: "left",
    },
    [theme.breakpoints.up("md")]: {
      fontSize: 25,
      textAlign: "left",
    },
    [theme.breakpoints.up("sm")]: {
      textAlign: "left",
    },
  },
  [`& .${classes.smsContent}`]: {
    // padding: "2em 1em 1em 1.75em",
    fontSize: 20,
    fontWeight: 100,
    width: "90%",
    color: "#223140",
    fontWeight: "400",
    fontFamily: "AvenirLTStd-Book",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      marginTop: "1em",
      fontSize: 16,
      textAlign: "left",
    },
    [theme.breakpoints.between("sm", "md")]: {
      padding: "2em 1em 1em 1em",
      fontSize: 25,
      textAlign: "left",
    },
    [theme.breakpoints.up("sm")]: {
      textAlign: "left",
      fontSize: 25,
      textAlign: "left",
    },
    [theme.breakpoints.up("md")]: {},
  },
  [`& .${classes.smsContent3}`]: {
    // padding: "2em 1em 1em 1.75em",
    fontSize: 20,
    fontWeight: 100,
    width: "100%",
    marginTop: "1em",
    color: "#223140",
    fontWeight: "400",
    fontFamily: "AvenirLTStd-Book",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      marginTop: "1em",
      fontSize: 16,
      textAlign: "left",
    },
    [theme.breakpoints.between("sm", "md")]: {
      padding: "2em 1em 1em 1em",
      fontSize: 20,
      textAlign: "left",
    },
    [theme.breakpoints.up("sm")]: {
      textAlign: "left",
      fontSize: 20,
      textAlign: "left",
    },
    [theme.breakpoints.up("md")]: {},
  },
  [`& .${classes.smsContent2}`]: {
    // padding: "2em 1em 1em 1.75em",
    fontSize: 20,
    fontWeight: 100,
    width: "90%",
    color: "#223140",
    fontFamily: "AvenirLTStd-Book",
    paddingTop: "2rem",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      marginTop: "1em",
      fontSize: 16,
      textAlign: "left",
    },
    [theme.breakpoints.between("sm", "md")]: {
      padding: "2em 1em 1em 1em",
      fontSize: 20,
      textAlign: "left",
    },
    [theme.breakpoints.up("sm")]: {
      textAlign: "left",
      fontSize: 20,
      textAlign: "left",
    },
    [theme.breakpoints.up("md")]: {},
  },
  [`& .${classes.smsContent4}`]: {
    // padding: "2em 1em 1em 1.75em",
    fontSize: 20,
    fontWeight: 100,
    width: "90%",
    color: "#223140",
    marginTop: "2rem",
    fontFamily: "AvenirLTStd-Book",
    paddingTop: "2rem",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      marginTop: "1em",
      fontSize: 16,
      textAlign: "left",
    },
    [theme.breakpoints.between("sm", "md")]: {
      padding: "2em 1em 1em 1em",
      fontSize: 20,
      textAlign: "left",
    },
    [theme.breakpoints.up("sm")]: {
      textAlign: "left",
      fontSize: 20,
      textAlign: "left",
    },
    [theme.breakpoints.up("md")]: {},
  },
  [`& .${classes.exploreButtonStyle}`]: {
    whiteSpace: "nowrap",
    background: "#B41E1C",
    color: "#fff",
    fontWeight: "none",
    fontFamily: "AvenirLTStd-Roman",
    "&:hover": {
      background: "#fff",
      color: "#B41E1C",
      boxShadow: "5px 5px 13px 5px rgba(0,0,0,0.15)",
    },
    [theme.breakpoints.down("sm")]: {
      width: 250,
      marginLeft: 0,
      fontSize: 15,
    },
    [theme.breakpoints.between("sm", "md")]: {
      width: 350,
      fontSize: 20,
      // width: '100%',
    },
    [theme.breakpoints.up("lg", "xl")]: {
      fontSize: 20, // fontSize: 30,
    },
  },
  [`& .${classes.buttonStyles}`]: {
    borderRadius: "24px",
    textTransform: "inherit",
    width: 400, // width: 200,
    fontSize: 20, // fontSize: 30,
    // fontSize: '0.9rem',
  },
  [`& .${classes.buttonContainer}`]: {
    marginTop: "1em",
    [theme.breakpoints.down("sm")]: {
      // justifyContent: "space-around",
    },
    [theme.breakpoints.between("sm", "md")]: {
      // justifyContent: "space-around",
      // background: 'red'
    },
  },
}));

function SmsSnippet({ tagline }) {
  return (
    <StyledGrid container className={classes.smsContainer}>
      {tagline ? (
        <Grid item size={{ sm: 12, md: 8, xs: 12 }} className={classes.smsData}>
          <Typography variant="h1" className={classes.smsHeading}>
            REDiFly SMS - Safety Management System
          </Typography>
          <Typography variant="body2" className={classes.smsContent}>
            Centralise your data and get real-time insights with a user-friendly
            system that simplifies safety and compliance management.
          </Typography>
          <Typography
            style={{
              marginTop: "1rem",
              fontSize: "24px",
              fontFamily: "AvenirLTStd-Book",
              textAlign: "left",
            }}
          >
            Simple, Efficient,{" "}
            <span style={{ fontSize: "24px", color: "red" }}>
              Safety Management.
            </span>
          </Typography>
        </Grid>
      ) : (
        <Grid item size={{ sm: 12, md: 8, xs: 12 }} className={classes.smsData}>
          <Typography className={classes.smsHeading2}>
            REDiFly SMS - A Simple Alternative to Outdated & Complex Systems
          </Typography>
          <Typography variant="body2" className={classes.smsContent3}>
            Centralise your data and get real-time insights with a user-friendly
            system that simplifies safety and compliance management.
          </Typography>
          <Grid container className={classes.buttonContainer} spacing={1}>
            <Button
              variant="contained"
              href="https://calendly.com/redifly/discoverycall"
              target="_blank"
              className={[
                classes.buttonStyles,
                classes.exploreButtonStyle,
              ].join(" ")}
            >
              Schedule a Discovery Call
            </Button>
          </Grid>
          <Typography className={classes.smsContent4}>
            We’ve spent the last few years speaking to safety & compliance
            managers. Most are facing the same problems…
          </Typography>
        </Grid>
      )}

      <Grid item size={{ sm: 12, md: 4, xs: 12 }}>
        <img src={SMS} alt="SMS Snippet" />
      </Grid>
    </StyledGrid>
  );
}

export default SmsSnippet;
